import { Injectable } from '@angular/core';
import { ICorporatePartner } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  HeaderFooterMachCore,
  LoggedInMilesAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { LoginFacadeHelperService } from './login-facade-helper.service';
@Injectable({
  providedIn: 'root'
})
export class LoginFacadeSupportService extends LoginFacadeHelperService {
  checkLabel(corpPartner: ICorporatePartner): string | undefined {
    return corpPartner.showBusinessMilesLabel || this.isBusiness
      ? this.milesLabelContent.loggedInMilesLabelBusiness
      : this.milesLabelContent.loggedInMilesLabel;
  }

  updateSessionTimeoutMessage(data: HeaderFooterMachCore): void {
    let logOutText = '';
    let loggedInText = '';
    let sessionTimeoutMessageTitle = '';

    if (data.sessionTimeoutMessage.logOutText) {
      logOutText = data.sessionTimeoutMessage.logOutText;
    }
    if (data.sessionTimeoutMessage.loggedInText) {
      loggedInText = data.sessionTimeoutMessage.loggedInText;
    }
    if (data.sessionTimeoutMessage.sessionTimeoutMessageTitle) {
      sessionTimeoutMessageTitle =
        data.sessionTimeoutMessage.sessionTimeoutMessageTitle;
    }
    this.updateSessionTimeoutContent({
      logoutText: logOutText,
      loggedInText: loggedInText,
      sessionTimeoutMessageTitle: sessionTimeoutMessageTitle
    });
  }

  updateSessionTimeoutDescription(data: HeaderFooterMachCore): void {
    let sessionTimeoutMessageDescription = '';
    let timeoutStayLogInText = '';
    let expiryTime = 0;
    if (data.sessionTimeoutMessage.expiryTime) {
      expiryTime = Number.parseInt(data.sessionTimeoutMessage.expiryTime);
    }
    if (
      data.sessionTimeoutMessage.sessionTimeoutMessageDescription &&
      data.sessionTimeoutMessage.sessionTimeoutMessageDescription.indexOf(
        '.'
      ) !== -1
    ) {
      timeoutStayLogInText =
        data.sessionTimeoutMessage.sessionTimeoutMessageDescription
          .split('.')[1]
          .trim();
      sessionTimeoutMessageDescription =
        data.sessionTimeoutMessage.sessionTimeoutMessageDescription.split(
          '.'
        )[0];
      sessionTimeoutMessageDescription = sessionTimeoutMessageDescription
        .split('{{')[0]
        .trim();
    }
    this.updateSessionTimeoutContent({
      sessionTimeoutMessageDescription: sessionTimeoutMessageDescription,
      timeoutStayLogInText: timeoutStayLogInText,
      expiryTime: expiryTime
    });
  }

  showSignUpLoginToolTip(): void {
    const isSkymilesMember = sessionStorage.getItem('v27') === 'Y';
    if (isSkymilesMember) {
      const hideLoginCookie =
        this.cookieHelper.getCookieValue('hideLoginTooltip');
      if (hideLoginCookie === null) {
        this.updateToolTipToggle({
          displayLoginToolTip: true,
          isToolTipisHidden: false
        });
      }
    } else {
      const hideSignUpCookie =
        this.cookieHelper.getCookieValue('hideSignUpTooltip');
      if (hideSignUpCookie === null) {
        this.updateToolTipToggle({
          displaySignUpToolTip: true,
          isToolTipisHidden: false
        });
      }
    }
  }

  showProfileSelector(): void {
    const accountCookie = this.cookieHelper.getCookieValue('account');
    if (accountCookie) {
      this.setIsBusiness(accountCookie);
    }
  }

  setMilesLabelContent(
    data: HeaderFooterMachCore,
    corpPartner: ICorporatePartner
  ): void {
    const milesLabelContent = data.header.auxiliaryNavigation.find(
      (item: { id: string }) => item.id === 'loggedInMilesLabel'
    );
    if (milesLabelContent) {
      this.milesLabelContent = milesLabelContent as LoggedInMilesAem;
      const labelName = this.checkLabel(corpPartner);
      if (labelName) {
        this.milesLabel.labelName = labelName;
      }
    }
  }

  checkSignUpLoginToolTip(): void {
    if (this.APP_NAME == 'homepage') {
      this.showSignUpLoginToolTip();
    }
  }
}
